import { createRouter, ErrorComponent } from '@tanstack/react-router';

import { routeTree } from './routeTree.gen';

declare module '@tanstack/react-router' {
  type Register = {
    router: typeof router;
  };
}

export const router = createRouter({
  routeTree,
  defaultErrorComponent: ({ error }) => <ErrorComponent error={error} />,
  context: {
    // Auth will initially be undefined
    // We'll be passing down the auth state from within a React component
    auth: undefined!,
    // We'll be passing down the queryClient from within a React component
    queryClient: undefined!,
  },
  defaultPreload: 'intent',
  // Since we're using React Query, we don't want loader calls to ever be stale
  // This will ensure that the loader is always called when the route is preloaded or visited
  defaultPreloadStaleTime: 0,
});
